import * as actionType from './actionTypes';
import { LOAD_SCOPE, QUEUE_VIEW } from '../../constants/onboardingQueue';

const emptyView = { items: [], total: 0, refused: false, error: null };

export const initialState = {
  [QUEUE_VIEW.PENDING]: emptyView,
  [QUEUE_VIEW.COMPLETED]: emptyView,
  filters: { search: '', from: null, to: null },
  loading: false,
  refreshing: false,
  loaded: false,
};

const withScope = (state, scope, value) => (
  scope === LOAD_SCOPE.VIEW
    ? { ...state, refreshing: value }
    : { ...state, loading: value }
);

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actionType.LOAD_STARTED: {
      const { filters, scope } = action.payload;
      return {
        ...withScope(state, scope, true),
        filters: filters || state.filters,
      };
    }
    case actionType.VIEW_LOADED: {
      const {
        view, items, total, refused,
      } = action.payload;
      return {
        ...state,
        [view]: {
          items, total, refused, error: null,
        },
      };
    }
    case actionType.VIEW_FAILED: {
      const { view, error } = action.payload;
      return {
        ...state,
        [view]: {
          items: [], total: 0, refused: false, error,
        },
      };
    }
    case actionType.LOAD_FINISHED: {
      const { scope } = action.payload;
      return {
        ...withScope(state, scope, false),
        loaded: scope === LOAD_SCOPE.VIEW ? state.loaded : true,
      };
    }
    case actionType.RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
